interface ILinkIsActive {
  isActive: boolean;
}

// this is utlity function to check if a link is active
const linkIsActive = ({ isActive }: ILinkIsActive) => {
  const commonStyle =
    "md:w-full flex items-center gap-2 p-2 rounded-lg on-hover hover-bg hover:text-pink-600";

  return isActive ? `${commonStyle} text-pink-600` : commonStyle;
};

export default linkIsActive;
